/**
 * @generated SignedSource<<a59a41ef9092bc3e770e24415d8d82ee>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type CheckoutBankAccounts_viewer$data = {
  readonly stripeIsEnabled: boolean | null;
  readonly " $fragmentSpreads": FragmentRefs<"CheckoutACHFormStripe_viewer" | "CheckoutACHForm_viewer" | "CheckoutBankAccountListWrapper_viewer" | "CheckoutPaymentError_viewer" | "CheckoutWireTransferForm_viewer" | "checkoutPayment_viewer">;
  readonly " $fragmentType": "CheckoutBankAccounts_viewer";
};
export type CheckoutBankAccounts_viewer$key = {
  readonly " $data"?: CheckoutBankAccounts_viewer$data;
  readonly " $fragmentSpreads": FragmentRefs<"CheckoutBankAccounts_viewer">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "CheckoutBankAccounts_viewer",
  "selections": [
    {
      "kind": "InlineDataFragmentSpread",
      "name": "checkoutPayment_viewer",
      "selections": [
        {
          "alias": "achDisabled",
          "args": [
            {
              "kind": "Literal",
              "name": "key",
              "value": "disableACHCheckout"
            }
          ],
          "kind": "ScalarField",
          "name": "isEnabled",
          "storageKey": "isEnabled(key:\"disableACHCheckout\")"
        },
        {
          "alias": "disableApplePay",
          "args": [
            {
              "kind": "Literal",
              "name": "key",
              "value": "disableApplePay"
            }
          ],
          "kind": "ScalarField",
          "name": "isEnabled",
          "storageKey": "isEnabled(key:\"disableApplePay\")"
        },
        {
          "alias": "isKlarnaNegotiationEnabled",
          "args": [
            {
              "kind": "Literal",
              "name": "feature",
              "value": "klarnaNegotiationFlow"
            }
          ],
          "kind": "ScalarField",
          "name": "featureFlag",
          "storageKey": "featureFlag(feature:\"klarnaNegotiationFlow\")"
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "Token",
          "kind": "LinkedField",
          "name": "clientToken",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "environment",
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "args": null,
      "argumentDefinitions": []
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "CheckoutPaymentError_viewer"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "CheckoutACHForm_viewer"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "CheckoutBankAccountListWrapper_viewer"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "CheckoutWireTransferForm_viewer"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "CheckoutACHFormStripe_viewer"
    },
    {
      "alias": "stripeIsEnabled",
      "args": [
        {
          "kind": "Literal",
          "name": "feature",
          "value": "stripeCheckout"
        }
      ],
      "kind": "ScalarField",
      "name": "featureFlag",
      "storageKey": "featureFlag(feature:\"stripeCheckout\")"
    }
  ],
  "type": "Viewer",
  "abstractKey": null
};

(node as any).hash = "2832cada8d499fa1c419ac1e74702ef0";

export default node;
